import { Container, Description, Icon, Row, Title } from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";
import { TextNodeType } from "@tm/isomorphic-utils";

interface PoweredByProps {
  title?: TextNodeType;
  icon?: string;
  iconsList?: string[];
  description?: TextNodeType;
}

export const PoweredBy = ({ title, icon, iconsList, description }: PoweredByProps) => {
  if (!title && !description && !icon && !iconsList?.length) return null;

  return (
    <Container>
      <Row>
        <Title>
          <FormattedText value={title || "Powered by"} />
        </Title>
        {iconsList?.length
          ? iconsList.map((url, index) => (
              <Icon key={index} src={url} alt={`powered by icon ${index + 1}`} />
            ))
          : icon ? <Icon src={icon} alt="powered by icon" /> : null}
      </Row>
      <Description>
        <FormattedText value={description} />
      </Description>
    </Container>
  );
};

